import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Routes from "./Routes";
import { userService } from "./libs/authLib";
//import "./App.css";
import ButtonAppBar from  "./components/ButtonAppBar";
import ButtonAppBarFooter from "./components/ButtonAppBarFooter";

class App extends Component {

  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      fields: {},
      organizationName: "",
      auth: false,
      disableMenu: false,
    };
  }

  handleChange = updatedValue => {
    this.setState({
      fields: {
        ...this.state.fields,
        ...updatedValue
      }      
    });
  }

  handleMenuDisplay = updatedValue => {
    this.setState({
      disableMenu: {
        ...this.state.disableMenu,
        ...updatedValue
      }      
    });  
  }
  
  componentDidMount() {   
    this._isMounted = true;
    try {
      if (userService.authUser()) {
        this.userHasAuthenticated(true);
      }
    }
    catch(e) {
      //alert(e);
    }
    if(this._isMounted){
      this.setState({ 
        isAuthenticating: false
      });
    }
  }
  componentWillUnmount(){
    this._isMounted = false;
  }

  userHasAuthenticated = authenticated => {
    if(this._isMounted){
      this.setState({ isAuthenticated: authenticated });
    }
  }

  handleLogout = event => {
    
    userService.logout();

    this.userHasAuthenticated(false);
    this.setState({disableMenu: false});
    window.AndroidInterface.logout();
    //this.props.history.push("/login");
  }

  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      handleChange: this.handleChange,
      fields: this.state.fields,
      handleLogout: this.handleLogout,
      disableMenu: this.state.disableMenu,
      handleMenuDisplay: this.handleMenuDisplay     
    };
    
    //console.log(childProps);
    
//  {/* <<NavItem onClick={this.handleLogout}>Logout</NavItem>              */}
    return  (

      !this.state.isAuthenticating &&   
      <div>                                           
        {this.state.isAuthenticated && 
          (!childProps.disableMenu && 
            <React.Fragment>
              <ButtonAppBar childProps={childProps}/>                             
            </React.Fragment>
          )            
        }                           
              <Routes childProps={childProps} />  
        {this.state.isAuthenticated &&
          <ButtonAppBarFooter props={childProps}/> 
        }                            
                                                                               
      </div>        
    );
  }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/App.js